/* eslint-disable import/prefer-default-export */
/* eslint-disable no-return-assign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react';
import { useTranslation } from '@rbx/intl';
import { Tooltip, IconButton } from '@rbx/ui';
import DocsSiteEventType from '@modules/eventStream/enum/DocsSiteEventType';
import { logTryItOutEvent } from '@modules/openCloud/swagger/components/tryItOut';
import { getEndpointRiskLevel } from '@modules/openCloud/swagger/config/endpointRiskLevels';
import { List, Map } from 'immutable';

// https://github.com/swagger-api/swagger-ui/blob/9c1e7699a7ba433f66cabc7eefa18579acf58c85/src/core/window.js
const win = (() => {
  let w: any = {
    location: {},
    history: {},
    open: () => undefined,
    close: () => undefined,
    FormData: () => undefined,
  };

  if (typeof window === 'undefined') {
    return w;
  }

  try {
    w = window;
    const props = ['File', 'Blob', 'FormData'];
    for (const prop of props) {
      if (prop in window) {
        w[prop as keyof typeof w] = window[prop as keyof typeof window];
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  return w;
})();

// https://github.com/swagger-api/swagger-ui/blob/9c1e7699a7ba433f66cabc7eefa18579acf58c85/src/core/plugins/request-snippets/fn.js
/**
 * if duplicate key name existed from FormData entries,
 * we mutated the key name by appending a hashIdx
 * @param {String} k - possibly mutated key name
 * @return {String} - src key name
 */
const extractKey = (k: string) => {
  const hashIdx = '_**[]';
  if (k.indexOf(hashIdx) < 0) {
    return k;
  }
  return k.split(hashIdx)[0].trim();
};

const escapeShell = (str: string) => {
  if (str === '-d ') {
    return str;
  }
  // eslint-disable-next-line no-useless-escape
  if (!/^[_\/-]/g.test(str)) return `'${str.replace(/'/g, "'\\''")}'`;
  return str;
};

function getStringBodyOfMap(request: {
  get: (arg0: string) => { (): any; new (): any; entrySeq: { (): any; new (): any } };
}) {
  const curlifyToJoin = [];
  for (const [k, v] of request.get('body').entrySeq()) {
    const extractedKey = extractKey(k);
    if (v instanceof win.File) {
      curlifyToJoin.push(
        `  "${extractedKey}": {\n    "name": "${v.name}"${v.type ? `,\n    "type": "${v.type}"` : ''}\n  }`,
      );
    } else {
      curlifyToJoin.push(
        `  "${extractedKey}": ${JSON.stringify(v, null, 2).replace(/(\r\n|\r|\n)/g, '\n  ')}`,
      );
    }
  }
  return `{\n${curlifyToJoin.join(',\n')}\n}`;
}

const curlify = (request: any, escape: (str: string) => string, newLine: string, ext = '') => {
  let isMultipartFormDataRequest = false;
  let curlified = '';
  const addWords = (...args: string[]) => (curlified += ` ${args.map(escape).join(' ')}`);
  const addWordsWithoutLeadingSpace = (...args: string[]) =>
    (curlified += args.map(escape).join(' '));
  const addNewLine = () => (curlified += ` ${newLine}`);
  const addIndent = (level = 1) => (curlified += '  '.repeat(level));
  const headers = request.get('headers');
  curlified += `curl${ext}`;

  const curlOptions = request.get('curlOptions');
  if (List.isList(curlOptions) && !curlOptions.isEmpty()) {
    addWords(...request.get('curlOptions'));
  }

  addWords('-X', request.get('method'));

  addNewLine();
  addIndent();
  addWordsWithoutLeadingSpace(`${request.get('url')}`);

  if (headers && headers.size) {
    for (const p of request.get('headers').entries()) {
      addNewLine();
      addIndent();
      const [h, v] = p;
      addWordsWithoutLeadingSpace('-H', `${h}: ${v}`);
      isMultipartFormDataRequest =
        isMultipartFormDataRequest ||
        (/^content-type$/i.test(h) && /^multipart\/form-data$/i.test(v));
    }
  }

  const body = request.get('body');
  if (body) {
    if (isMultipartFormDataRequest && ['POST', 'PUT', 'PATCH'].includes(request.get('method'))) {
      for (const [k, v] of body.entrySeq()) {
        const extractedKey = extractKey(k);
        addNewLine();
        addIndent();
        addWordsWithoutLeadingSpace('-F');

        /**
         * SwaggerClient produces specialized sub-class of File class, that only
         * accepts string data and retain this data in `data`
         * public property throughout the lifecycle of its instances.
         *
         * This sub-class is exclusively used only when Encoding Object
         * is defined within the Media Type Object (OpenAPI 3.x.y).
         */
        if (v instanceof win.File && typeof v.valueOf() === 'string') {
          addWords(`${extractedKey}=${v.data}${v.type ? `;type=${v.type}` : ''}`);
        } else if (v instanceof win.File) {
          addWords(`${extractedKey}=@${v.name}${v.type ? `;type=${v.type}` : ''}`);
        } else {
          addWords(`${extractedKey}=${v}`);
        }
      }
    } else if (body instanceof win.File) {
      addNewLine();
      addIndent();
      addWordsWithoutLeadingSpace(`--data-binary '@${body.name}'`);
    } else {
      addNewLine();
      addIndent();
      addWordsWithoutLeadingSpace('-d ');
      let reqBody = body;
      if (!Map.isMap(reqBody)) {
        if (typeof reqBody !== 'string') {
          reqBody = JSON.stringify(reqBody);
        }
        addWordsWithoutLeadingSpace(reqBody);
      } else {
        addWordsWithoutLeadingSpace(getStringBodyOfMap(request));
      }
    }
  } else if (!body && request.get('method') === 'POST') {
    addNewLine();
    addIndent();
    addWordsWithoutLeadingSpace("-d ''");
  }

  return curlified;
};

export const requestSnippetGenerator_curl_bash = (request: any) => {
  return curlify(request, escapeShell, '\\\n');
};

// https://github.com/swagger-api/swagger-ui/blob/9c1e7699a7ba433f66cabc7eefa18579acf58c85/src/core/components/curl.jsx
const DetailsSwaggerUICurl = ({ getComponent, request }: any) => {
  const { translate } = useTranslation();
  const curl = requestSnippetGenerator_curl_bash(request);
  const SyntaxHighlighter = getComponent('SyntaxHighlighter', true);

  const method = request?.method?.toUpperCase() || 'GET';
  const url = request?.url || '';
  const riskLevel = getEndpointRiskLevel(method, '', url);

  const handleCopyClick = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(curl);
      logTryItOutEvent(DocsSiteEventType.TryItOutClickCopyCurl, {
        method,
        url,
        riskLevel,
      });
    } catch {
      // Fallback for older browsers or if clipboard API fails
    }
  }, [curl, method, url, riskLevel]);

  return (
    <div className='curl-command'>
      <h4>Curl</h4>
      <div className='copy-to-clipboard'>
        <Tooltip title={translate('Description.TryItOutCurlCopyWarning')}>
          <IconButton
            onClick={handleCopyClick}
            aria-label={translate('Description.TryItOutCurlCopyWarning')}
            size='small'
          />
        </Tooltip>
      </div>
      <div>
        <SyntaxHighlighter
          language='bash'
          className='curl microlight'
          renderPlainText={({ children, PlainTextViewer }: any) => (
            <PlainTextViewer className='curl'>{children}</PlainTextViewer>
          )}>
          {curl}
        </SyntaxHighlighter>
      </div>
    </div>
  );
};

export default DetailsSwaggerUICurl;
